import { TabSettingPageProps } from 'types/TabSettingPageProps';

export const tabsList: TabSettingPageProps[] = [
	{
		id: 0,
		name: 'Componentes',
		isSelected: true
	},
	{
		id: 1,
		name: 'Páginas',
		isSelected: false
	}
	// {
	// 	id: 2,
	// 	name: 'Whitelist',
	// 	isSelected: false
	// }
];
